import { render, staticRenderFns } from "./ListGithubRepositoryView.vue?vue&type=template&id=5b912370"
import script from "./ListGithubRepositoryView.vue?vue&type=script&lang=ts"
export * from "./ListGithubRepositoryView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports